import ApiService from "@/services/api.service";
import store from "@/store/index";
import {NotifiyClient} from "@/models/notification";

export const project = {
    namespaced: true,
    state: {
        my:null,
        projects:null,
        selected:null,
        onboarding:null

    },
    actions: {
        getOnboardingOfProject({commit},id){
            if(id) {
                return ApiService.post("onboarding/get", {id:id}).then(
                    response => {
                        commit('getOnboardingSuccess', response.data);
                    },
                    error => {
                        console.error(error);
                        store.dispatch("notificationsStore/add", new NotifiyClient("warning", "Fehler", false, "."))
                    });
            }
        },
        getMyProjects({commit}){
            return ApiService.get("project/mine").then(
                response => {
                    commit('getMyProjectsSuccess',response.data);
                },
                error =>{
                    console.error(error);
                    store.dispatch("notificationsStore/add",new NotifiyClient("warning","Fehler",false,"Deine Projekte konnten nicht geladen werden."))
                });
        },
    },
    mutations:{
        getMyProjectsSuccess(state,data){
            state.my=data;
            state.selected=data[0];
        },
        getOnboardingSuccess(state,data){
            state.onboarding=data;
        },
    }
}